import { Pipe, PipeTransform } from '@angular/core';
import { differenceInCalendarDays, parse, startOfMonth } from 'date-fns';

@Pipe({
  standalone: false,
  name: 'liteCalReservationHeightOffset',
})
export class LiteCalReservationHeightOffsetPipe implements PipeTransform {
  transform(reservation: any, currentDate: any): any {
    const resStartDate = parse(reservation.start_date);
    const firstDayOfMonth = startOfMonth(currentDate);

    const lengthOfReservationInDays = differenceInCalendarDays(resStartDate, firstDayOfMonth);

    return lengthOfReservationInDays * 40 + 10;
  }
}
